// src/com/file_of_report/TransPlanResultReportDef.js
// 운송실적 레포트 정의

import { AppWord, TableColumnType, TopCode } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";

const TransPlanResultReportMetaForFresh = {
    instructions: {
        title: '운송실적 Report(신선)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF33FF33', // light green (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const TransPlanResultReportMetaForAccustom = {
    instructions: {
        title: '운송실적 Report(상온)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF66CCFF', // light blue (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const TransPlanResultReportMetaForExpress = {
    instructions: {
        title: '운송실적 Report(Exp.)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FFFFC0CB', // light pink (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

export const TransPlanResultReportMeta = {
    fresh: TransPlanResultReportMetaForFresh,
    express: TransPlanResultReportMetaForExpress,
    accustom: TransPlanResultReportMetaForAccustom,
};

const TransPlanResultReportMetaForFreshTranscom = {
    instructions: {
        title: '운송사 운송실적 Report(신선)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF33FF33', // light green (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const TransPlanResultReportMetaForAccustomTranscom = {
    instructions: {
        title: '운송사 운송실적 Report(상온)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF66CCFF', // light blue (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const TransPlanResultReportMetaForExpressTranscom = {
    instructions: {
        title: '운송사 운송실적 Report(Exp.)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FFFFC0CB', // light pink (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

export const TransPlanResultReportMetaForTranscom = {
    fresh: TransPlanResultReportMetaForFreshTranscom,
    accustom: TransPlanResultReportMetaForAccustomTranscom,
    express: TransPlanResultReportMetaForExpressTranscom,
};

function returnZeroIfNull(row, value) {
    if(!Boolean(value)) return 0;
    return value;
}

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..
// Express 운송사 운송실적 레포트 컬럼 정의
const TransPlanResultReportExcelColumnsForExpressTranscom = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'dcName', width: 120, label: '출발지', option:{type:TableColumnType.TEXT} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [ {label:'운송거리', colSpan:2}, ]
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'eFDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'전면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eFDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eFRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eFPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eFPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'중면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eMDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eMPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'후면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eRDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eRPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'TOTAL', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'expressDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'expressPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eCigar', width: 72, label: '담배',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:7}],
        excel: returnZeroIfNull
    },
    {
        id: 'eCorn', width: 72, label: '양곡',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'ePulp', width: 72, label: '제지류',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMu', width: 72, label: 'MU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'점간대출', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumRoll', width: 72, label: 'Roll Cage',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'basicCharge', width: 96, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 96, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 96, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'note', width: 150, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
];

// 운송사 운송실적레포트 (상온)
const TransPlanResultReportExcelColumnsForAccustomTranscom = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'dcName', width: 120, label: '출발지', option:{type:TableColumnType.TEXT} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [ {label:'운송거리', colSpan:2}, ]
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'aPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기', colSpan:13}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aRollN', width: 72, label: '일반',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'RollCage', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aRollJum', width: 72, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aB2bKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'B2B Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aB2bAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpSpec', width: 72, label: '특정',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Other Pallet', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpJum', width: 72, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpTrunc', width: 72, label: 'Trunking',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aHiDanpra', width: 72, label: '단프라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'고 가 상 품', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aHiRoll', width: 72, label: '롤케이지',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aEtc', width: 72, label: '기타',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'aTray', width: 72, label: 'Tray',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'basicCharge', width: 96, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 96, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 96, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'note', width: 150, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
];

// 운송사 운송실적레포트 (신선)
const TransPlanResultReportExcelColumnsForFreshTranscom = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'dcName', width: 120, label: '출발지', option:{type:TableColumnType.TEXT} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [ {label:'운송거리', colSpan:2}, ],
        excel: returnZeroIfNull
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER},
        // excel: returnZeroIfNull
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    // 전면
    {
        id: 'fFPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'전면', colSpan:6}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fFPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fFShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fFShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fFEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fFEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    // 중면
    {
        id: 'fMPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'중면', colSpan:6}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fMShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fMEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    // 후면
    {
        id: 'fRPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'후면', colSpan:6}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fRPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fRShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fRShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fREtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fREtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    // TOTAL
    {
        id: 'freshPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'TOTAL', colSpan:7}, {label:'Pallet', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'freshPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshPalKppAju', width: 72, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'freshShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'freshEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fNjc', width: 72, label: 'NJC',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:4}],
        excel: returnZeroIfNull
    },
    {
        id: 'fUcolor', width: 72, label: '우든칼라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'fOctagon', width: 72, label: '옥타곤',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'fTray', width: 72, label: '싱글트레이',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull,
    },
    {
        id: 'basicCharge', width: 72, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 72, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 88, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'memo', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
];

// 운송실적레포트 (Express)
const TransPlanResultReportExcelColumnsForExpress = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [ {label:'운송거리', colSpan:2}, ],
        excel: returnZeroIfNull
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'basicCharge', width: 72, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 72, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 88, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'tempF', width: 56, label: '전면', // NOT inputTempF
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'출발기준온도', colSpan:3}]
    },
    {
        id: 'tempM', width: 56, label: '중면', // NOT inputTempM
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'tempR', width: 56, label: '후면', // NOT inputTempR
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'eFDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'전면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eFDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eFRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eFPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eFPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'중면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eMDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eMPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'후면', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'eRDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eRPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'eRPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'TOTAL', colSpan:5}],
        excel: returnZeroIfNull
    },
    {
        id: 'expressDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'expressPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'expressPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eCigar', width: 72, label: '담배',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:7}],
        excel: returnZeroIfNull
    },
    {
        id: 'eCorn', width: 72, label: '양곡',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'ePulp', width: 72, label: '제지류',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eMu', width: 72, label: 'MU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [ null, {label:'점간대출', colSpan:3} ],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'eJumRoll', width: 72, label: 'Roll Cage',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    { id: 'loadStaffName', width: 120, label: '상차작업자', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    { id: 'memo', width: 152, label: '특이사항', option:{type:TableColumnType.TEXT} },
];

// 운송실적레포트 (상온)
const TransPlanResultReportExcelColumnsForAccustom = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'transType', width: 88, label: '배차구분',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(row.dcCd === TopCode.DcCode.AdcAnsung) {
                // 안성ADC만 운송실적 리포트 엑셀파일에서 배차구분 항목 
                // 값을 출발요청시간이 22:00이면 ‘익일’, 그외 시간은 ‘당일’로 표시가 가능한지 검토 부탁드립니다
                if(row.dptrReqTime && row.dptrReqTime.indexOf('22:00') > 9) return '익일';
                else return '당일';
            }
            return value;
        }
    },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'운송거리', colSpan:2},
        ],
        excel: returnZeroIfNull
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'basicCharge', width: 96, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 96, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 120, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 152, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'note', width: 200, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'aPalKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'물류집기', colSpan:13},
            {label:'Pallet', colSpan:2}
        ],
        excel: returnZeroIfNull
    },
    {
        id: 'aPalAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aRollN', width: 96, label: '일반',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'RollCage', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aRollJum', width: 96, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aB2bKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'B2B Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aB2bAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpSpec', width: 96, label: '특정',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Other Pallet', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpJum', width: 96, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aOpTrunc', width: 96, label: 'Trunking',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aHiDanpra', width: 96, label: '고가단프라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'고 가 상 품', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'aHiRoll', width: 96, label: '양곡단프라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'aEtc', width: 96, label: '기타',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'aTray', width: 96, label: 'Tray',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    { id: 'loadStaffName', width: 96, label: '상차작업자', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    { id: 'memo', width: 200, label: '특이사항', option:{type:TableColumnType.TEXT} },
];


// 운송실적레포트 (신선)
const TransPlanResultReportExcelColumnsForFresh = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    {
        id: 'distanceOne', width: 64, label: 'km(편도)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'운송거리', colSpan:2},
        ],
        excel: returnZeroIfNull
    },
    {
        id: 'distanceRound', width: 64, label: 'km(왕복)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'basicCharge', width: 96, label: '기본운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'운반비', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'addCharge', width: 96, label: '추가운임',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'transCharge', width: 120, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT},
        excel: (row, value) => {
            if(!Boolean(value)) return ':';
            return value;
        }
    },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'unitCost', width: 96, label: 'Unit Cost', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        excel: (row, value) => {
            if(!row.loadCountTotal) return row.transCharge;
            return row.loadCountTotal === 0 ? row.transCharge : (row.transCharge / row.loadCountTotal);
        }
    },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}],
        excel: returnZeroIfNull
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'tempF', width: 56, label: '전면', // NOT inputTempF
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'출발기준온도', colSpan:3}]
    },
    {
        id: 'tempM', width: 56, label: '중면', // rowspan to be 2. NOT inputTempM
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'tempR', width: 56, label: '후면', // rowspan to be 2. NOT inputTempR
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'fFPalKpp', width: 80, label: 'KPP',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'전면', colSpan:6},
            {label:'Pallet', colSpan:2}
        ],
        excel: returnZeroIfNull
    },
    {
        id: 'fFPalAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fFShrFull', label: 'Full', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fFShrHalf', label: 'Half', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fFEtcKpp', label: 'KPP', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fFEtcAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fMPalKpp', width: 80, label: 'KPP',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [{label: '중면', colSpan: 6}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMPalAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fMShrFull', label: 'Full', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMShrHalf', label: 'Half', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fMEtcKpp', label: 'KPP', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fMEtcAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fRPalKpp', width: 80, label: 'KPP',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [{label: '후면', colSpan: 6}, {label:'Pallet', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fRPalAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fRShrFull', label: 'Full', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fRShrHalf', label: 'Half', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fREtcKpp', label: 'KPP', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'fREtcAju', label: 'AJU', width: 80,
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshPalKpp', width: 80, label: 'KPP',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'TOTAL', colSpan:7},
            {label:'Pallet', colSpan:3}
        ],
        excel: returnZeroIfNull
    },
    {
        id: 'freshPalAju', width: 80, label: 'AJU',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshPalKppAju', width: 80, label: '합계',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshShrFull', width: 80, label: 'Full',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'freshShrHalf', width: 80, label: 'Half',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'freshEtcKpp', width: 80, label: 'KPP',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}],
        excel: returnZeroIfNull
    },
    {
        id: 'freshEtcAju', width: 80, label: 'AJU',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null, null],
        excel: returnZeroIfNull
    },
    {
        id: 'fNjc', width: 88, label: 'NJC',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:4}],
        excel: returnZeroIfNull
    },
    {
        id: 'fUcolor', width: 88, label: '우든칼라',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'fOctagon', width: 88, label: '옥타곤',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    {
        id: 'fTray', width: 88, label: '싱글트레이',
        option: {type:TableColumnType.INTEGER},
        superHeaders: [null],
        excel: returnZeroIfNull
    },
    { id: 'loadStaffName', width: 96, label: '상차작업자', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    { id: 'memo', width: 168, label: '특이사항', option:{type:TableColumnType.TEXT} },
];

export const TransPlanResultReportExcelColumns = {
    express: TransPlanResultReportExcelColumnsForExpress,
    accustom: TransPlanResultReportExcelColumnsForAccustom,
    fresh: TransPlanResultReportExcelColumnsForFresh,
};

export const TransPlanResultReportExcelColumnsForTranscom = {
    fresh: TransPlanResultReportExcelColumnsForFreshTranscom,
    accustom: TransPlanResultReportExcelColumnsForAccustomTranscom,
    express: TransPlanResultReportExcelColumnsForExpressTranscom
}